import React, { useState, useEffect } from "react";
import * as S from "./styles";

import RightNav from "./RightNav";
import { useLocation } from "react-router";
import { useWindowDimension } from "../../shared/utils/CustomHooks";

export default function Burger() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const dimensions = useWindowDimension();

    useEffect(() => {
        setOpen(false);
    }, [location]);

    return (
        <>
            <S.StyledBurger
                open={open}
                onClick={() => setOpen(!open)}
                dimensions={dimensions}
            >
                <div />
                <div />
                <div />
            </S.StyledBurger>
            <RightNav open={open} />
        </>
    );
}
